// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"d7ede721","188":"b94f31e3","197":"c86242ee","210":"a54ded0a","896":"2f90fd2f","936":"b01ba83a"}[chunkId] + ".css";
};